import { render, staticRenderFns } from "./SponsorProvidersDropDown.vue?vue&type=template&id=bf2afbf2"
import script from "./SponsorProvidersDropDown.vue?vue&type=script&lang=js"
export * from "./SponsorProvidersDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports